import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';

import Sidebar from '../Layouts/Sidebar';
import TopBar from '../Layouts/TopBar';
import Cookies from 'js-cookie';
import instance from '../Config/AxiosConfig';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { useDelete } from '../Context/ApiContext';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

function Communities() {
  const [communities, setCommunities] = useState([]);

  const [selectedCommunity, setSelectedCommunity] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const membersPerPage = 10;
  // leave community
  const { handleSearch, handleJoin, deleteItem, deleteResponse, join, resultSearch, search, setSearch, activeTab, setActiveTab } = useDelete();

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const api = "/communities/leave"

  useEffect(() => {
    instance.get('/communities/getAll')
      .then(response => {
        setCommunities(response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [deleteResponse, join]);



  const [results, setResults] = useState([]);
  const { interests } = useDelete(); // Utilisez le contexte pour obtenir les centres d'intérêt


  useEffect(() => {
    const fetchCommunitiesByInterest = async () => {
      const token = Cookies.get('token');
      const data = new FormData();
      interests.forEach(interest => data.append('interests[]', 225));

      try {
        const response = await instance.post('/communities/getAllFromInterests', data, token);
        setResults(response.data);
        console.log('Communities by interest:', response.data);
      } catch (error) {
        console.error('Error fetching communities by interest:', error);
      }
    };

    if (interests.length > 0) {
      fetchCommunitiesByInterest();
    }
  }, [interests]);


  useEffect(() => {
    const fakeEvent = {
      preventDefault: () => { } // Définir une fonction  pour éviter l'erreur
    };
    handleSearch(fakeEvent); // Appeler handleSearch avec un événement fake
  }, [search]);



  return (
    <>
      <TopBar />
      <main>
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-3">
              <Sidebar />
            </div>
            <div className="col-md-8 col-lg-6 vstack gap-4">
              {/* Card START */}
              <div className="card ">
                {/* Card header START */}
                <div className="card-header border-0 pb-0">
                  <div className=" d-sm-flex justify-content-between align-items-center mb-5">
                    <h1 className="h4 ">Discover communities</h1>
                    <div className="nav  px-4 px-lg-0"><div className="nav-item ">
                      <form className="rounded position-relative" onSubmit={handleSearch}>
                        <input className="form-control ps-5 bg-light" value={search}
                          onChange={(e) => setSearch(e.target.value)} type="search" placeholder="Join..." aria-label="Search" />
                        <button className="btn bg-transparent px-2 py-0 position-absolute top-50 start-0 translate-middle-y" type="submit"><i className="bi bi-search fs-5"> </i></button>
                      </form>
                    </div>
                    </div>
                  </div>
                </div>

                {/* Card header START */}
                {/* Card body START */}
                <div className="card-body">
                  {/* Tab nav line */}
                  <ul className="nav nav-tabs nav-bottom-line justify-content-center justify-content-md-start" role="tablist">
                    <li className="nav-item" role="presentation">
                      <a
                        className={`nav-link active ${activeTab === 'tab-1' ? 'active' : ''}`}
                        data-bs-toggle="tab"
                        href="#tab-1"
                        aria-selected={activeTab === 'tab-1'}
                        role="tab"
                        onClick={() => handleTabClick('tab-1')}
                      >
                        My communities
                      </a>
                    </li>
                    <li className="nav-item " role="presentation">
                      <a
                        className={`nav-link ${activeTab === 'tab-2' ? 'active' : ''}`}
                        data-bs-toggle="tab"
                        href="#tab-2"
                        aria-selected={activeTab === 'tab-2'}
                        role="tab"
                        onClick={() => handleTabClick('tab-2')}
                      >
                        Suggested for me
                      </a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a
                        className={`nav-link ${activeTab === 'tab-4' ? 'active' : ''}`}
                        data-bs-toggle="tab"
                        href="#tab-4"
                        aria-selected={activeTab === 'tab-4'}
                        role="tab"
                        onClick={() => handleTabClick('tab-4')}
                      >
                        More suggestions
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content mb-0 pb-0">
                    {/* Friends groups tab START */}
                    <div className={`tab-pane  fade ${activeTab === 'tab-1' ? 'show active' : ''}`} id="tab-1" role="tabpanel">

                      <div className="row g-4">

                        {/* Card START */}
                        {(communities.length !== 0) ? communities.map((community) => (
                          <div className="col-sm-6 col-lg-4" key={community.id}>
                            <div className="card h-100">
                              <div className="h-80px rounded-top" style={{ backgroundImage: 'url(https://social.webestica.com/assets/images/bg/05.jpg)', backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} />

                              <div className="card-body text-center pt-0">
                                {/* Avatar */}
                                <div className="avatar avatar-lg mt-n5 mb-3">
                                  <img className="avatar-img rounded-circle border border-white border-3 bg-white" src={community.image} alt="" />
                                </div>
                                {/* Info */}
                                <h5 className="mb-0"> <a href={"/communitydetails/" + community.id}>{community.name.length > 30 ? community.name.slice(0, 30) + "..." : community.name}</a> </h5>
                                <small> <i className="bi bi-lock pe-1" /> Private Group</small>
                                {/* Group stat START */}
                                <div className="hstack gap-2 gap-xl-3 justify-content-center mt-3">
                                  {/* Group stat item */}
                                  <div>
                                    <h6 className="mb-0">{community.members.length}</h6>
                                    <small>Members</small>
                                  </div>
                                  {/* Divider */}
                                  <div className="vr" />
                                  {/* Group stat item */}
                                  <div>
                                    <h6 className="mb-0">{community.createdAt ? community.createdAt.slice(0, 10) : (<i className="bi bi-calendar-check pe-1" />)}</h6>
                                    <small>Date</small>
                                  </div>
                                </div>
                                {/* Group stat END */}
                                {/* Avatar group START */}
                                <ul className="avatar-group list-unstyled align-items-center justify-content-center mb-0 mt-3">

                                  {community.members.slice(0, 5).map((member, index) => (
                                    <li key={index} className="avatar avatar-xs">
                                      <img
                                        className="avatar-img rounded-circle"
                                        src={member.profilePicture}
                                        alt="avatar"
                                      />
                                    </li>
                                  ))}
                                  {community.members.length > 5 && (
                                    <li className="avatar avatar-xs"  >
                                      <div className="avatar-img rounded-circle bg-primary">
                                        <span className="smaller text-white position-absolute top-50 start-50 translate-middle">+{community.members.length - 5}</span>
                                      </div>
                                    </li>
                                  )}
                                </ul>
                                {/* Avatar group END */}
                              </div>
                              {/* Card body END */}
                              {/* Card Footer START */}
                              <div className="card-footer text-center">
                                <a className="btn btn-danger-soft btn-sm" href="#!" onClick={() => deleteItem(api, community.id)}> leave community </a>
                              </div>
                              {/* Card Footer END */}
                            </div>
                          </div>
                        ))
                          :
                          <>
                            <div className="my-sm-5 py-sm-5 text-center">
                              <i className="display-1 text-body-secondary bi bi-people"> </i>
                              <h4 className="mt-2 mb-3 text-body">No community founds</h4>
                              <button className="btn btn-primary-soft btn-sm" data-bs-toggle="modal" data-bs-target="#modalCreateGroup"> Click here to add </button>
                            </div>
                          </>}
                        {/* Card END */}


                      </div>
                    </div>
                    {/* Friends' groups tab END */}



                    {/* Suggested for you START */}
                    <div className={`tab-pane fade ${activeTab === 'tab-2' ? 'show active' : ''}`} id="tab-2" role="tabpanel">
                      <div className="row g-4">

                        {/* Card START */}
                        {(results.length !== 0) ? results.map((community) => (
                          <div className="col-sm-6 col-lg-4" key={community.id}>
                            <div className="card h-100">
                              <div className="h-80px rounded-top" style={{ backgroundImage: 'url(https://social.webestica.com/assets/images/bg/05.jpg)', backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} />

                              <div className="card-body text-center pt-0">
                                {/* Avatar */}
                                <div className="avatar avatar-lg mt-n5 mb-3">
                                  <a href=""><img className="avatar-img rounded-circle border border-white border-3 bg-white" src={community.image} alt="" /></a>
                                </div>
                                {/* Info */}
                                <h5 className="mb-0"> <a href={"/communitydetails/" + community.id}>{community.name.length > 30 ? community.name.slice(0, 30) + "..." : community.name}</a> </h5>
                                <small> <i className="bi bi-lock pe-1" /> Private Group</small>
                                {/* Group stat START */}
                                <div className="hstack gap-2 gap-xl-3 justify-content-center mt-3">
                                  {/* Group stat item */}
                                  <div>
                                    <h6 className="mb-0">{community.members.length}</h6>
                                    <small>Members</small>
                                  </div>
                                  {/* Divider */}
                                  <div className="vr" />
                                  {/* Group stat item */}
                                  <div>
                                    <h6 className="mb-0">{community.createdAt ? community.createdAt.slice(0, 10) : (<i className="bi bi-calendar-check pe-1" />)}</h6>


                                    <small>Date</small>
                                  </div>
                                </div>
                                {/* Group stat END */}
                                {/* Avatar group START */}
                                <ul className="avatar-group list-unstyled align-items-center justify-content-center mb-0 mt-3">

                                  {community.members.slice(0, 5).map((member, index) => (
                                    <li key={index} className="avatar avatar-xs">
                                      <img
                                        className="avatar-img rounded-circle"
                                        src={member.profilePicture}
                                        alt="avatar"
                                      />
                                    </li>
                                  ))}
                                  {community.members.length > 5 && (
                                    <li className="avatar avatar-xs"  >
                                      <div className="avatar-img rounded-circle bg-primary">
                                        <span className="smaller text-white position-absolute top-50 start-50 translate-middle">+{community.members.length - 5}</span>
                                      </div>
                                    </li>
                                  )}
                                </ul>
                                {/* Avatar group END */}
                              </div>
                              {/* Card body END */}
                              {/* Card Footer START */}
                              <div className="card-footer text-center">
                                <a className="btn btn-success-soft btn-sm" href="#!" onClick={() => handleJoin(community.id)}> Join community </a>
                              </div>
                              {/* Card Footer END */}
                            </div>
                          </div>
                        ))
                          :
                          <>
                            <div className="my-sm-5 py-sm-5 text-center">
                              <i className="display-1 text-body-secondary bi bi-people"> </i>
                              <h4 className="mt-2 mb-3 text-body">No community founds</h4>
                              <button className="btn btn-primary-soft btn-sm" data-bs-toggle="modal" data-bs-target="#modalCreateGroup"> Click here to add </button>
                            </div>
                          </>
                        }
                        {/* Card END */}

                      </div>
                    </div>
                    {/* more for you START */}
                    <div className={`tab-pane fade ${activeTab === 'tab-4' ? 'show active' : ''}`} id="tab-4" role="tabpanel">
                      {/* Add group */}

                      <div className="row g-4">

                        {/* Card START */}
                        {(resultSearch.length !== 0) ? resultSearch.map((community) => (
                          <div className="col-sm-6 col-lg-4" key={community.id}>
                            <div className="card h-100">
                              <div className="h-80px rounded-top" style={{ backgroundImage: 'url(https://social.webestica.com/assets/images/bg/05.jpg)', backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} />

                              <div className="card-body text-center pt-0">
                                {/* Avatar */}
                                <div className="avatar avatar-lg mt-n5 mb-3">
                                  <img className="avatar-img rounded-circle border border-white border-3 bg-white" src={community.image} alt="" />
                                </div>
                                {/* Info */}
                                <h5 className="mb-0"> <a href={"/communitydetails/" + community.id}>{community.name.length > 30 ? community.name.slice(0, 30) + "..." : community.name}</a> </h5>
                                <small> <i className="bi bi-lock pe-1" /> Private Group</small>
                                {/* Group stat START */}
                                <div className="hstack gap-2 gap-xl-3 justify-content-center mt-3">
                                  {/* Group stat item */}
                                  <div>
                                    <h6 className="mb-0">{community.members.length}</h6>
                                    <small>Members</small>
                                  </div>
                                  {/* Divider */}
                                  <div className="vr" />
                                  {/* Group stat item */}
                                  <div>
                                    <h6 className="mb-0">{community.createdAt ? community.createdAt.slice(0, 10) : (<i className="bi bi-calendar-check pe-1" />)}</h6>
                                    <small>Date</small>
                                  </div>
                                </div>
                                {/* Group stat END */}
                                {/* Avatar group START */}
                                <ul className="avatar-group list-unstyled align-items-center justify-content-center mb-0 mt-3">

                                  {community.members.slice(0, 5).map((member, index) => (
                                    <li key={index} className="avatar avatar-xs">
                                      <img
                                        className="avatar-img rounded-circle"
                                        src={member.profilePicture}
                                        alt="avatar"
                                      />
                                    </li>
                                  ))}
                                  {community.members.length > 5 && (
                                    <li className="avatar avatar-xs">
                                      <div className="avatar-img rounded-circle bg-primary">
                                        <span className="smaller text-white position-absolute top-50 start-50 translate-middle">+{community.members.length - 5}</span>
                                      </div>
                                    </li>
                                  )}
                                </ul>
                                {/* Avatar group END */}
                              </div>
                              {/* Card body END */}
                              {/* Card Footer START */}
                              <div className="card-footer text-center">
                                <a className="btn btn-success-soft btn-sm" href="#!" onClick={() => handleJoin(community.id)}>join community </a>
                              </div>
                              {/* Card Footer END */}
                            </div>
                          </div>
                        ))
                          :
                          <>
                            <div className="my-sm-5 py-sm-5 text-center">
                              <i className="display-1 text-body-secondary bi bi-people"> </i>
                              <h4 className="mt-2 mb-3 text-body">No community founds</h4>
                            </div>
                          </>}
                        {/* Card END */}


                      </div>
                    </div>
                    {/* More suggestions END */}
                  </div>
                </div>
                {/* Card body END */}
              </div>
              {/* Card END */}
            </div>
          </div>
        </div>



      </main>
    </>
  );
}

export default Communities;
